import { supabase, isSupabaseConfigured } from '@/integrations/supabase';

/**
 * 현재 저장된 Supabase 인증 세션을 조회합니다.
 */
export async function getAuthSession() {
  if (!isSupabaseConfigured) {
    return { session: null, user: null, error: null };
  }

  try {
    const { data, error } = await supabase.auth.getSession();
    if (error) {
      return { session: null, user: null, error };
    }
    return {
      session: data.session,
      user: data.session?.user || null,
      error: null,
    };
  } catch (err) {
    return {
      session: null,
      user: null,
      error: err instanceof Error ? err : new Error('세션 조회 중 오류가 발생했습니다.'),
    };
  }
}
